import { render, staticRenderFns } from "./RecordsOfForm.vue?vue&type=template&id=e961c864&"
import script from "./RecordsOfForm.vue?vue&type=script&lang=js&"
export * from "./RecordsOfForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports